export const getLocale = function() {
    return window.localStorage.getItem('LOCALE_OVERRIDE') || window.current_language;
}

export const loadLanguage = async function(language) {
    const locale = getLocale();
    if (window.translations === undefined) {
        window.translations = {};
    }
    window.translations[locale] = await (await fetch(
        `${window.endpoint_translations}/${locale}`
    )).json();
}

export const lang = function(translationKey, keys) {
    const locale = getLocale();
    const wantKeysOrNotLoadedInYet =
        window.localStorage.getItem('TOGGLE_LOCALE_STRINGS') ||
        window.translations === undefined ||
        window.translations[locale] === undefined

    if (wantKeysOrNotLoadedInYet) {
        return translationKey
    }

    var trans = window.translations[locale][translationKey];
    if (trans && trans.length > 0) {
        if (keys) {
            for (var key in keys) {
                // eslint-disable-next-line no-prototype-builtins
                if (!keys.hasOwnProperty(key)) continue;

                var value = keys[key];
                var lang_key = ":" + key + " ";
                trans = trans.replace(lang_key, value);
            }
        }

        if (window.devmode) {
            trans += " (" + translationKey + ")";
            if (keys) trans += " " + JSON.stringify(keys);
        }
        return trans;
    } else {
        //Check if the key already does not exist. Only if in devmode
        if (window.devmode) {
            var arrayIndex = window.translation_keys.indexOf(translationKey);
            if (arrayIndex === -1) {
                //check if string contains at least one . (to work with Laravel)
                var stringIndex = translationKey.indexOf(".");
                if (stringIndex === -1) {
                    console.error(
                        'translation key "' +
                        translationKey +
                        '" needs to have at least one . in it.'
                    );
                } else {
                    //should send the data to DB
                    var data = {
                        key: translationKey
                    };
                    // eslint-disable-next-line no-undef
                    Vue.http.post("language/register-key", data, function() { });
                }
            }
        }
        return translationKey;
    }
}
